<template>
    <div>
        <form class="mb-4">
            <div class="row">
                <div class="col-12 col-md-12" v-for="network  in availableNetworks" :key="network.code">
                    <div class="form-group">
                        <label :for="'network-' + network.code">{{ network.label }}</label>
                        <b-form-input
                            v-model="model[network.code]"
                            type="text"
                            :placeholder="network.placeholder || ''"
                        ></b-form-input>
                    </div>
                </div>
            </div>
            <input type="hidden" v-model="company._v"/>
            <button-loading
                class="btn btn-lg btn-primary mb-3"
                :loading="isSavePending"
                @click="saveCompany()"
            >{{$t('Save')}}
            </button-loading>
        </form>
    </div>
</template>

<script>
    import Navigation from './Navigation.vue';
    import ButtonLoading from '@/components/ButtonLoading'
    import {companyMixins} from './mixins.js'

    export default {
        mixins: [companyMixins],
        components: {
            Navigation,
            ButtonLoading
        },
        watch: {
            model: {
                handler(newValue) {
                    this.company.socials = newValue;
                },
                deep: true
            }
        },
        data() {
            return {
                availableNetworks: [
                    {label: 'Telegram', code: 'telegram', placeholder: 'Type telegram channel url'},
                    {label: 'Instagram', code: 'instagram', placeholder: 'Type instagram page url'},
                    {label: 'Facebook', code: 'facebook'},
                    {label: 'Twiter', code: 'twitter'},
                    {label: 'Pinterest', code: 'pinterest'},
                ],
                model: {},

            };
        },

        created() {
            this.getMyCompany("mine").then(data => {
                this.model = data.socials || {};
            });
        }
    }
</script>
